import createEmotion from 'create-emotion';

const { css, cx, keyframes } = createEmotion({
  // The key option is required when there will be multiple instances in a single app
  key: 'commandbar-proxy',
  container: document.getElementById('proxy-wrapper') || undefined,
});

export { css, cx, keyframes };
